<template>
  <div class="rating-wrapper">
    <span :class="'rating ' + className">{{ letter }}</span>
    <div class="rating-label">{{ metric }}</div>
  </div>
</template>

<script>
export default {
  name: 'RatingBadge',
  props: {
    rating: {
      type: Number,
      default: 0
    },
    metric: {
      type: String,
      required: true
    }
  },
  computed: {
    className() {
      const current = this.ratings.find(r => r.value === this.rating)
      return `rating-${current.label}`
    },
    letter() {
      const current = this.ratings.find(r => r.value === this.rating)
      return current.label
    }
  },
  data() {
    return {
      ratings: [
        {
          label: 'N',
          value: 0
        },
        {
          label: 'A',
          value: 1,
          className: 'Green'
        },
        {
          label: 'B',
          value: 2,
          color: 'Green'
        },
        {
          label: 'C',
          value: 3,
          color: 'Green'
        },
        {
          label: 'D',
          value: 4,
          color: 'Red'
        },
        {
          label: 'E',
          value: 5,
          color: 'Red'
        }
      ]
    }
  }
}
</script>

<style scoped>
.rating {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 24px;
  box-sizing: border-box;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.35);
}
.rating-N {
  background-color: var(--v-rating_N-base);
}
.rating-A {
  background-color: var(--v-rating_A-base);
}
.rating-B {
  background-color: var(--v-rating_B-base);
}
.rating-C {
  background-color: var(--v-rating_C-base);
}
.rating-D {
  background-color: var(--v-rating_D-base);
}
.rating-E {
  background-color: var(--v-rating_E-base);
}
</style>
